module.exports = __webpack_public_path__ + "static/media/video-solid.32221391.svg";